export type Path = {
  name: string;
  url: string;
};

export const BACKFILL_PATH: Path = {
  name: 'Backfill',
  url: '/backfill',
};

export const TICKETING_PATH = 'https://t.corp.amazon.com/create/templates/c703a509-e339-4d91-9721-36a4c12a1669';
export const INTAKE_FOLDER_PATH = 'https://sim.amazon.com/issues/create?template=38d9b3cc-fe36-4752-bf6d-9dde558de511';
